export enum HolidayErrorMessage {
  CODE_REQUIRED = 'Code is required',
  DATE_REQUIRED = 'Date is required',
  DESCRIPTION_REQUIRED = 'Description is required',
  HOLIDAY_REQUIRED = 'Holiday is required',
  NAME_REQUIRED = 'Name is required'
}

export interface HolidayDateModel {
  code?: string;
  date: Date;
  description: string;
  holidayId: number;
  id: number;
  year: number;
}

export interface HolidayModel {
  code: string;
  description: string;
  id: number;
  name: string;
}
